<template>
    <div style="padding-bottom: 40px">
        <M3Warn v-if="data && data.m3_project && data.m3_project.duplicate_sections && data.m3_project.duplicate_sections.includes('financial_request')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(data.m3_project.duplicate_company_id)"></M3Warn>
        <CFTitle title="9. Context"></CFTitle>
        <validation-observer #default="{ invalid }" ref="context">
            <span class="display-none">{{ invalid }}</span>
            <M3Warn type="yellow" text="În cadrul acestei secțiuni se vor prezenta, cu titlu de exemplu, următoarele:<ul><li>Contextul promovării proiectului, precum și complementaritatea cu alte proiecte finanțate din fonduri europene sau alte surse</li><li>Date generale privind investiția propusă</li><li>Componentele și activitățile investiției, și modul în care acoperă/soluționează problemele identificate în  secțiunea Justificarea proiectului</li><li>Aspecte detaliate legate de locația de implementare a proiectului</li></ul>" ></M3Warn>
            <validation-provider
                #default="{ errors }"
                rules="required"
            >
                <CFTextarea v-model="form.context" :read-only="completed" :limit="10500"></CFTextarea>
                <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <hr class="mt-4">
        </validation-observer>
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle"
    import CFTextarea from "./CFTextarea";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    import { BFormInput, BFormGroup, BFormCheckbox, BIconInfoCircleFill, BTooltip } from "bootstrap-vue";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';


    export default {
        name: "CFContext",
        components:{
            CFTitle,
            CFTextarea,
            M3Warn,
            BFormInput, BFormGroup, BFormCheckbox, BIconInfoCircleFill, BTooltip,
            ValidationProvider,
            ValidationObserver,
        },
        props:{
            m3GrantApplication: {
                type: Object,
                default: null
            },
            data: {
                type: Object,
                default: null
            },
            indicators: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                completed: null,
                form: {
                    context: '',
                }
            }
        },
        computed: {
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            finantareProgress() {
                return this.$store.getters['finantare/progress']
            }
        },
        watch: {
            finantareProgress: {
                handler: function() {
                    if(this.finantareProgress && this.finantareProgress.includes('Context')) {
                        this.completed = true
                    }
                },
                deep: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.context)
                        this.form.context= this.m3GrantApplication.context.context;
                },
                deep: true
            }
        },
        mounted() {
            if(this.m3GrantApplication && this.m3GrantApplication.context){
                this.form.context= this.m3GrantApplication.context.context;
            } else {
                let locations = 1
                let locationsNumber = ''
                let locationsText = []
                if(this.data && this.data.m3_project &&this.data.m3_project.location_address){
                    locations = this.data.m3_project.location_address.length
                    if(locations === 1){
                        locationsNumber = '1 locație de implementare'
                        locationsText = 'Locația de implementare a proiectului este '+ this.data.m3_project.location_address[0].address +', aflată în regiunea '+ this.data.m3_project.location_address[0].region +', regiune eligibilă conform Ghidului Solicitantului.'
                    } else{
                        locationsNumber = ''+ locations +' locații de implementare'
                        this.data.m3_project.location_address.forEach(locatie => {
                            locationsText += 'Locația de implementare a proiectului este '+ locatie.address +', aflată în regiunea '+ locatie.region +', regiune eligibilă conform Ghidului Solicitantului. \n \n'
                        })
                    }
                }
                this.form.context = 'Investiția vizată în proiect contribuie la sprijinirea capacității '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' de a crește pe piețe regionale, naționale și internaționale și de a se angaja în procese de inovarea prin dezvoltarea produselor / seviciilor. Investiția are ca scop ameliorarea efectelor provocate de criză în contextul pandemiei de COVID-19 și al consecințelor sale sociale. Totodată, vine în întâmpinarea provocărilor generate de tranziția spre o economie verde, digitală și rezilientă prin achiziția de echipamente ___________ și de software ___________. \n' +
                    '\n' +
                    ''+ (this.indicators ? this.indicators.environment_percentage : '-') +'% din bugetul total al proiectului contribuie la obiectivele de mediu, respectând în totalitate prevederile Anexei I din  REGULAMENTUL DELEGAT AL COMISIEI (UE) de completare a Regulamentului (UE) 2020/852 al Parlamentului European și al Consiliului privind stabilirea criteriilor tehnice de screening pentru determinarea condițiilor în care o activitate economică se califică ca contribuind în mod substanțial la atenuarea schimbărilor climatice sau adaptarea la schimbările climatice.\n' +
                    '\n' +
                    'Proiectul propune '+ locationsNumber +' \n' +
                    '\n' +
                    ''+ locationsText +''
            }

            if(this.finantareProgress && this.finantareProgress.includes('Context')) {
                this.completed = true
            }
        },
        methods:{
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            sendForm(){
                if(this.completed){
                    this.$refs.context.validate().then((e) => {
                        if (!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {context: this.form})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$emit('savedData')
                                    this.$store.dispatch('finantare/addToProgress', 'Context')
                                })
                        }
                    })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Context')
                }
            }
        }
    }
</script>

<style scoped>
div >>> ul{
  list-style: inside;
}
</style>
